export const blockIconsActionFace = (
	<span className='material-symbols-outlined'>face</span>
);
